import styled from 'styled-components';

export const DotsButton = styled.div`
  position: absolute;
  top: 20px;
  right: 10px;
  cursor: pointer;
  color: var(--color-text-muted);

  :hover {
    color: var(--color-accent);
  }
`;
